import Debtor from '@/views/debtor/Debtor.vue'

const router = {
    path: '/debtor',
    name: 'Debtor',
    component: Debtor,
    meta: {
        title: 'Debtor'
    }
  };

export default router
